import { Link } from "react-router-dom";

export const renderLinkOrSpan = (
    item: { title: string; url: string },
    className = "",
    customRoute?: string,
    isEmail = false
) =>
    isEmail ? (
        <a
            href={`mailto:${item.title}`}
            className={`text-decoration-none ${className}`}
        >
            {item.title}
        </a>
    ) : item?.url ? (
        <Link to={customRoute || item.url} className={`text-decoration-none ${className}`}>
            {item.title}
        </Link>
    ) : (
        <span className={className}>{item.title}</span>
    );
